'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var IconStatic16_1 = __importDefault(require('../../IconStatic16'));

var CheckSmall16 = function CheckSmall16(props) {
  return react_1.default.createElement(
    IconStatic16_1.default,
    __assign({}, props),
    react_1.default.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.0305 6.02953L7.53051 10.5295C7.23762 10.8224 6.76274 10.8224 6.46985 10.5295L3.96985 8.02953L5.03051 6.96887L7.00018 8.93854L10.9698 4.96887L12.0305 6.02953Z',
    })
  );
};

CheckSmall16.displayName = 'CheckSmall16';
exports.default = CheckSmall16;
